import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const ProductReach = () => {
  const { t } = useTranslation();

  const floatingFruits = [
    { emoji: "🍍", delay: 0, duration: 6, x: "10%", y: "20%" },
    { emoji: "🥥", delay: 1, duration: 7, x: "80%", y: "15%" },
    { emoji: "🥥", delay: 2, duration: 8, x: "15%", y: "70%" },
    { emoji: "🍌", delay: 1.5, duration: 6.5, x: "85%", y: "65%" },
    { emoji: "🍍", delay: 3, duration: 7.5, x: "50%", y: "10%" },
    { emoji: "🥥", delay: 2.5, duration: 6, x: "45%", y: "80%" },
  ];
  <div itemScope itemType="https://schema.org/QuantitativeValue">
    <span itemProp="value">15+</span>
    <span itemProp="unitText">Countries</span>
  </div>;
  
  return (
    <section className="relative py-20 bg-gradient-to-br from-green-50 via-emerald-50 to-green-100 dark:from-dark-900 dark:via-dark-800 dark:to-dark-900 overflow-hidden">
      {/* Wave Animation Background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <svg
          className="absolute bottom-0 w-full h-48 text-green-100 dark:text-dark-800 opacity-50"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <motion.path
            fill="currentColor"
            d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,144C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            animate={{
              d: [
                "M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,144C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,128L48,138.7C96,149,192,171,288,165.3C384,160,480,128,576,128C672,128,768,160,864,165.3C960,171,1056,149,1152,133.3C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,144C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              ],
            }}
            transition={{
              repeat: Infinity,
              duration: 10,
              ease: "easeInOut",
            }}
          />
        </svg>

        {/* Second Wave */}
        <svg
          className="absolute bottom-0 w-full h-48 text-emerald-100 dark:text-dark-700 opacity-30"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <motion.path
            fill="currentColor"
            d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            animate={{
              d: [
                "M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,224L48,213.3C96,203,192,181,288,186.7C384,192,480,224,576,234.7C672,245,768,235,864,213.3C960,192,1056,160,1152,165.3C1248,171,1344,213,1392,234.7L1440,256L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
                "M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z",
              ],
            }}
            transition={{
              repeat: Infinity,
              duration: 15,
              ease: "easeInOut",
            }}
          />
        </svg>
      </div>

      {/* Floating Fruits */}
      {floatingFruits.map((fruit, index) => (
        <motion.div
          key={index}
          className="absolute text-6xl pointer-events-none opacity-20 dark:opacity-10"
          style={{ left: fruit.x, top: fruit.y }}
          animate={{
            y: [0, -30, 0],
            rotate: [0, 10, -10, 0],
            scale: [1, 1.1, 1],
          }}
          transition={{
            repeat: Infinity,
            duration: fruit.duration,
            delay: fruit.delay,
            ease: "easeInOut",
          }}
        >
          {fruit.emoji}
        </motion.div>
      ))}

      <div className="container mx-auto px-6 lg:px-16 xl:px-24 relative z-10">
        {/* Section Title - Reduced Size */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            <span className="text-gray-900 dark:text-white">
              {t("productReach.title.part1")}
            </span>{" "}
            <span className="text-primary-600 dark:text-primary-400">
              {t("productReach.title.highlight")}
            </span>
          </h2>
        </motion.div>

        {/* Main Content: Text Left + Map Right */}
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left Side - Description Text (No Background) */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-6"
          >
            <div className="rounded-2xl p-2">
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed text-base">
                {t("productReach.description.part1")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight1")}
                </span>
                ,{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight2")}
                </span>{" "}
                {t("productReach.description.part2")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight3")}
                </span>{" "}
                {t("productReach.description.part3")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight4")}
                </span>{" "}
                {t("productReach.description.part4")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight5")}
                </span>{" "}
                {t("productReach.description.part5")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight6")}
                </span>{" "}
                {t("productReach.description.part6")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight7")}
                </span>
                ,{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight8")}
                </span>{" "}
                {t("productReach.description.part7")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight9")}
                </span>{" "}
                {t("productReach.description.part8")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight10")}
                </span>{" "}
                {t("productReach.description.part9")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight11")}
                </span>{" "}
                {t("productReach.description.part10")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight12")}
                </span>
                ,{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight13")}
                </span>
                , {t("productReach.description.part11")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight14")}
                </span>{" "}
                {t("productReach.description.part12")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight15")}
                </span>{" "}
                {t("productReach.description.part13")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight16")}
                </span>
                ,{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight17")}
                </span>{" "}
                {t("productReach.description.part14")}{" "}
                <span className="font-bold">
                  {t("productReach.description.highlight18")}
                </span>{" "}
                {t("productReach.description.part15")}
              </p>
            </div>
          </motion.div>

          {/* Right Side - World Map */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <div className="bg-white/80 dark:bg-dark-800/80 backdrop-blur-sm rounded-2xl p-8 shadow-xl">
              <div className="relative">
                <img
                  src="/images/world-map.svg"
                  alt={t("productReach.map.alt")}
                  className="w-full h-auto opacity-80 dark:opacity-60"
                />

                {/* Animated Pins for Key Markets */}
                <motion.div
                  className="absolute top-[35%] left-[20%] w-4 h-4 bg-primary-600 rounded-full"
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ repeat: Infinity, duration: 2 }}
                >
                  <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-xs font-semibold text-gray-900 dark:text-white whitespace-nowrap">
                    {t("productReach.map.locations.europe")}
                  </span>
                </motion.div>

                <motion.div
                  className="absolute top-[30%] left-[15%] w-4 h-4 bg-primary-600 rounded-full"
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ repeat: Infinity, duration: 2, delay: 0.5 }}
                >
                  <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-xs font-semibold text-gray-900 dark:text-white whitespace-nowrap">
                    {t("productReach.map.locations.uk")}
                  </span>
                </motion.div>

                <motion.div
                  className="absolute top-[25%] left-[12%] w-4 h-4 bg-primary-600 rounded-full"
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ repeat: Infinity, duration: 2, delay: 1 }}
                >
                  <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-xs font-semibold text-gray-900 dark:text-white whitespace-nowrap">
                    {t("productReach.map.locations.canada")}
                  </span>
                </motion.div>

                <motion.div
                  className="absolute top-[30%] right-[25%] w-4 h-4 bg-primary-600 rounded-full"
                  animate={{ scale: [1, 1.5, 1] }}
                  transition={{ repeat: Infinity, duration: 2, delay: 1.5 }}
                >
                  <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 text-xs font-semibold text-gray-900 dark:text-white whitespace-nowrap">
                    {t("productReach.map.locations.japan")}
                  </span>
                </motion.div>
              </div>

              {/* Market Stats */}
              <div className="mt-6 grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-primary-600 dark:text-primary-400">
                    {t("productReach.stats.countries.value")}
                  </div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">
                    {t("productReach.stats.countries.label")}
                  </div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary-600 dark:text-primary-400">
                    {t("productReach.stats.farmers.value")}
                  </div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">
                    {t("productReach.stats.farmers.label")}
                  </div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-primary-600 dark:text-primary-400">
                    {t("productReach.stats.since.value")}
                  </div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">
                    {t("productReach.stats.since.label")}
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProductReach;
